import * as AccordionUi from "@/components/ui/accordion";
import { Faq } from "@/lib/api";

const { Accordion, AccordionContent, AccordionItem, AccordionTrigger } = AccordionUi as any;

export function FaqList({ items, testPrefix = "faq", dark = false }: { items: Faq[]; testPrefix?: string; dark?: boolean }) {
  return (
    <Accordion type="single" collapsible className={`divide-y border-y ${dark ? "divide-cream/10 border-cream/10" : "divide-forest/10 border-forest/10"}`} data-testid={`${testPrefix}-list`}>
      {items.map((f, i) => (
        <AccordionItem key={f.question} value={`q${i}`} className="border-0">
          <AccordionTrigger data-testid={`${testPrefix}-item-${i}`} className={`py-6 text-left font-display text-2xl font-normal hover:no-underline sm:text-[1.7rem] ${dark ? "text-cream" : "text-forest"}`}>
            {f.question}
          </AccordionTrigger>
          <AccordionContent className={`max-w-2xl pb-6 text-base leading-relaxed ${dark ? "text-cream/80" : "text-charcoal-soft"}`}>{f.answer}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
